import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';

class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(16,185,129,0.08),_transparent_34%),linear-gradient(180deg,#f8fafc_0%,#eff6ff_100%)] p-4">
          <div className="w-full max-w-xl rounded-[28px] border border-slate-200 bg-white p-8 text-center shadow-[0_20px_60px_rgba(15,23,42,0.08)]">
            <h1 className="mb-2 text-xl font-semibold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Jjuma Pay had trouble loading
            </h1>
            <p className="text-sm text-slate-500">
              Please refresh the page. If this keeps happening, there may be a browser or deployment issue preventing the app from booting.
            </p>
            {this.state.error?.message && (
              <pre className="mt-4 whitespace-pre-wrap rounded-xl bg-slate-50 p-4 text-left text-xs text-slate-700 border border-slate-200 overflow-auto max-h-64">
                {String(this.state.error.message)}
                {this.state.errorInfo?.componentStack ? `\n\n${this.state.errorInfo.componentStack}` : ''}
              </pre>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

function AppShell() {
  React.useEffect(() => {
    const bootstrap = document.getElementById('app-bootstrap');
    if (bootstrap) {
      bootstrap.remove();
    }
  }, []);

  return <App />;
}

const bootstrap = document.getElementById('app-bootstrap');
if (bootstrap) {
  bootstrap.remove();
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <AppShell />
    </RootErrorBoundary>
  </React.StrictMode>,
);
